<style>
  .handsontable table thead th {
    white-space: pre-line;
  }

  #input_sheet_div {
    /*height: 500px;*/
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .handsontable .relative {
    position: relative;
    text-align: left;
  }

</style>

<div id="input_sheet_div" style="width: 100%; height:100%;" [style.height]="window_height?.toString() + 'px'">
  <div #input_sheet></div>
</div>
